// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const salandit: PokeData = {
  "id": 757,
  "name": "salandit",
  "height": 6,
  "weight": 48,
  "base_experience": 64,
  "types": [
    PokeType.POISON,
    PokeType.FIRE
  ],
  "api_moves": [
    "double-slap",
    "scratch",
    "ember",
    "flamethrower",
    "dragon-rage",
    "toxic",
    "smog",
    "poison-gas",
    "sweet-scent",
    "endeavor",
    "poison-fang",
    "dragon-pulse",
    "nasty-plot",
    "venoshock",
    "flame-burst",
    "incinerate",
    "venom-drench"
  ],
  "moves": [
    "scratch",
    "ember",
    "flamethrower",
    "poison-gas",
    "poison-fang",
    "dragon-pulse",
    "venom-drench",
    "sludge-bomb",
    "acid-rain",
    "magma-storm",
    "stun-spore",
    "acid",
    "flare-blitz"
  ],
  "evolution_chain": {
    "id": 390,
    "item": null,
    "species": [
      {
        "name": "salandit",
        "order": 757,
        "types": [
          PokeType.POISON,
          PokeType.FIRE
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "salazzle",
        "order": 758,
        "types": [
          PokeType.POISON,
          PokeType.FIRE
        ],
        "evolves_from_species_id": 757,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 33,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": {
              "name": "female"
            }
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 44,
    "speed": 77,
    "ability_power": 71
  },
  "stat_changes": [],
  "catch_rate": 120,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
